import {
  setFetching,
  setError,
  resetRequest,
} from "../../shared/request/actions/requestActions";
import {
  assignParticipantContent,
  getAssignedContentById,
  getContentById,
  markParticipantContentAsWatched,
  getCategoryById,
  getResourceTypes,
  getAllMyAssignedContent,
  getAssignedContent,
  getRelatedContent,
} from "../service";
import { getErrorMessageFromRequestError } from "../../shared/helpers/messages/request";
import {
  SET_EDITING_ASSIGNED_CONTENT,
  RESET_EDITING_ASSIGNED_CONTENT,
  MARK_AS_WATCHED_EDITING_ASSIGNED_CONTENT,
  MARK_AS_TO_WATCH_EDITING_ASSIGNED_CONTENT,
  SET_ALL_MY_ASSIGNED_CONTENT,
  SET_UPDATED_CONTENT_IN_LIST,
  SET_CONTENT_TYPES,
  RESET_CURRENT_CONTENT,
  SET_RELATED_CONTENT,
} from "./actionsTypes";
import { UNASSIGNED } from "../consts/assignedContentStatus";

export const resetCurrentContent = () => ({ type: RESET_CURRENT_CONTENT });

export const setEditingAssignedContent = ({
  assignedContent,
  content,
  resourceTypes,
}) => ({
  type: SET_EDITING_ASSIGNED_CONTENT,
  payload: { assignedContent, content, resourceTypes },
});

export const resetEditingAssignedContent = () => ({
  type: RESET_EDITING_ASSIGNED_CONTENT,
});

export const markEditingAssignedContentAsWatched = () => ({
  type: MARK_AS_WATCHED_EDITING_ASSIGNED_CONTENT,
});

export const markEditingAssignedContentAsToWatch = () => ({
  type: MARK_AS_TO_WATCH_EDITING_ASSIGNED_CONTENT,
});

export const setAllMyAssignedContent = (assignedContent) => ({
  type: SET_ALL_MY_ASSIGNED_CONTENT,
  payload: { assignedContent },
});

export const setUpdatedAssignedContentInList = (assignedContent) => ({
  type: SET_UPDATED_CONTENT_IN_LIST,
  payload: { assignedContent },
});

const setContentTypes = (contentTypes) => ({
  type: SET_CONTENT_TYPES,
  payload: { contentTypes },
});

const setRelatedContent = (relatedContent) => ({
  type: SET_RELATED_CONTENT,
  payload: relatedContent,
});

export const asyncGetFullAssignedContentInfo =
  (assignedContentId) => async (dispatch) => {
    dispatch(resetRequest());
    dispatch(setFetching({ isFetching: true }));
    try {
      let resourceTypes = [];
      const assignedContentResponse = await getAssignedContentById(
        assignedContentId
      );
      const assignedContent = assignedContentResponse.data.data;
      const contentResponse = await getContentById(assignedContent.contentId);
      const content = contentResponse.data.data;
      if (content.contentType === "Resource") {
        const resourceTypesResponse = await getResourceTypes();
        resourceTypes = resourceTypesResponse.data.data;
      }
      const categoryResponse = await getCategoryById(content.categoryId);
      const category = categoryResponse.data.data;
      content.categoryName = category.name;
      dispatch(
        setEditingAssignedContent({ assignedContent, content, resourceTypes })
      );
    } catch (error) {
      const message = getErrorMessageFromRequestError(error);

      dispatch(setError({ isOpen: true, message, type: "error" }));
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncGetContentById = (contentId) => async (dispatch) => {
  dispatch(resetRequest());
  dispatch(setFetching({ isFetching: true }));
  try {
    const contentResponse = await getContentById(contentId);
    const content = contentResponse.data.data;
    dispatch(
      setEditingAssignedContent({
        assignedContent: undefined,
        content,
        resourceTypes: [],
      })
    );
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncGetAssignedContentById = (contentId) => async (dispatch) => {
  try {
    const contentResponse = getAssignedContentById(contentId);
    const content = contentResponse.data.data;
    dispatch(
      setEditingAssignedContent({
        assignedContent: undefined,
        content,
        resourceTypes: [],
      })
    );
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncAssignParticipantContent =
  (contentId) => async (dispatch) => {
    dispatch(resetRequest());
    dispatch(setFetching({ isFetching: true }));
    try {
      await assignParticipantContent({ contentIds: [contentId] });
      dispatch(markEditingAssignedContentAsToWatch());
      dispatch(
        setError({
          isOpen: true,
          message: "The content was successfully marked as To watch",
          type: "success",
        })
      );
    } catch (error) {
      const message = getErrorMessageFromRequestError(error);

      dispatch(setError({ isOpen: true, message, type: "error" }));
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncMarkParticipantContentAsWatched =
  (contentId) => async (dispatch) => {
    dispatch(resetRequest());
    dispatch(setFetching({ isFetching: true }));
    try {
      await markParticipantContentAsWatched(contentId);
      dispatch(markEditingAssignedContentAsWatched());
      dispatch(
        setError({
          isOpen: true,
          message: "The content was successfully marked as watched",
          type: "success",
        })
      );
    } catch (error) {
      const message = getErrorMessageFromRequestError(error);

      dispatch(setError({ isOpen: true, message, type: "error" }));
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncFetchAllMyAssignedContent = () => async (dispatch) => {
  dispatch(resetRequest());
  dispatch(setFetching({ isFetching: true }));
  try {
    const response = await getAllMyAssignedContent();
    dispatch(setAllMyAssignedContent(response.data.data.data));
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncAssignMyContentFromContentList =
  (contentId) => async (dispatch) => {
    dispatch(resetRequest());
    dispatch(setFetching({ isFetching: true }));
    try {
      const response = await assignParticipantContent({
        contentIds: [contentId],
      });
      const [assignedContent] = response.data.data.assignedContent;
      const assignedContentResponse = await getAssignedContentById(
        assignedContent.assignedContentId
      );
      dispatch(
        setUpdatedAssignedContentInList(assignedContentResponse.data.data)
      );
      dispatch(
        setError({
          isOpen: true,
          message: "The content was successfully marked as To Watch",
          type: "success",
        })
      );
    } catch (error) {
      let message = "";
      if (error.response.data) {
        message = error.response.data.errors.length
          ? error.response.data.errors.toString()
          : error.response.data.warnings.toString();
      } else message = "Unexpected error";

      dispatch(setError({ isOpen: true, message, type: "error" }));
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };

export const asyncGetFullContentInfo = (contentId) => async (dispatch) => {
  dispatch(resetRequest());
  dispatch(setFetching({ isFetching: true }));
  try {
    let resourceTypes = [];
    const assignedContent = { statusId: 0 };
    const contentResponse = await getContentById(contentId);
    const content = contentResponse.data.data;
    if (content.contentType === "Resource") {
      const resourceTypesResponse = await getResourceTypes();
      resourceTypes = resourceTypesResponse.data.data;
    }
    const categoryResponse = await getCategoryById(content.categoryId);
    const category = categoryResponse.data.data;
    content.categoryName = category.name;

    const responseAssigned = await getAssignedContent({
      KeyWord: content.title,
      PageNumber: 1,
      PageSize: 1,
    });

    assignedContent.statusId =
      responseAssigned.data.data.data[0]?.statusId || UNASSIGNED;
    dispatch(
      setEditingAssignedContent({ assignedContent, content, resourceTypes })
    );
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncGetResourcesType = () => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));

  try {
    const { data } = await getResourceTypes();
    dispatch(setContentTypes(data.data));
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncGetRelatedContent = (contentId) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    const response = await getRelatedContent(contentId);
    const relatedContent = response.data.data;
    const contentResponse = await getContentById(contentId);
    const mainContent = contentResponse.data.data;
    const totalRelatedContent = [{ ...mainContent }, ...relatedContent];
    dispatch(setRelatedContent(totalRelatedContent));
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);
    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};
